"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EncodingType = void 0;
var EncodingType;
(function (EncodingType) {
    /** Device header */
    EncodingType[EncodingType["MessageType"] = 0] = "MessageType";
    /** Signed byte */
    EncodingType[EncodingType["Int8"] = 1] = "Int8";
    /** Unsigned byte */
    EncodingType[EncodingType["U8Int"] = 2] = "U8Int";
    /** Signed short integer (little-endian) */
    EncodingType[EncodingType["Int16LE"] = 3] = "Int16LE";
    /** Signed short integer (big-endian) */
    EncodingType[EncodingType["Int16BE"] = 4] = "Int16BE";
    /** @deprecated Signed integer — use {@link Int32LE | `Int32LE`} instead */
    EncodingType[EncodingType["Int32"] = 5] = "Int32";
    /** Signed integer (little-endian) */
    EncodingType[EncodingType["Int32LE"] = 6] = "Int32LE";
    /** Signed integer (big-endian) */
    EncodingType[EncodingType["Int32BE"] = 7] = "Int32BE";
    /** Unsigned short integer (little-endian) */
    EncodingType[EncodingType["U16IntLE"] = 8] = "U16IntLE";
    /** Unsigned short integer (big-endian) */
    EncodingType[EncodingType["U16IntBE"] = 9] = "U16IntBE";
    /** Two floats together for latitude and logitude, respectively (optionally includes speed, heading, HDOP, etc.) */
    EncodingType[EncodingType["Geo"] = 10] = "Geo";
    /** A single byte where bits are mapped to boolean values */
    EncodingType[EncodingType["StatusBit"] = 11] = "StatusBit";
    /** @deprecated ??? */
    EncodingType[EncodingType["VariableU8Int"] = 12] = "VariableU8Int";
    /** @deprecated ??? */
    EncodingType[EncodingType["RuleNumberCount"] = 13] = "RuleNumberCount";
    /** @deprecated ??? */
    EncodingType[EncodingType["GPS"] = 14] = "GPS";
    /** Unsigned integer (little-endian) */
    EncodingType[EncodingType["U32IntLE"] = 15] = "U32IntLE";
    /** Unsigned integer (big-endian) */
    EncodingType[EncodingType["U32IntBE"] = 16] = "U32IntBE";
    /** Unsigned long integer (little-endian) */
    EncodingType[EncodingType["U64IntLE"] = 17] = "U64IntLE";
    /** Unsigned long integer (big-endian) */
    EncodingType[EncodingType["U64IntBE"] = 18] = "U64IntBE";
    /** A half-precision float */
    EncodingType[EncodingType["FP16"] = 19] = "FP16";
    /** @deprecated ??? */
    EncodingType[EncodingType["PulseCountByQuadrant"] = 20] = "PulseCountByQuadrant";
})(EncodingType || (exports.EncodingType = EncodingType = {}));
